import { ChakraV3 } from '@piccolohealth/ui';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { AddNodeButton } from './AddNodeMenu';
import { AlignmentSelect } from './AlignmentSelect';
import { CommentButton } from './comment/CommentButton';
import { IndentSelect } from './IndentSelect';
import { MarkSelect } from './MarkSelect';
import { NodeTypeSelect } from './NodeTypeSelect';
import { TextColorSelect } from './TextColorSelect';
import { UndoRedo } from './UndoRedo';
import { VerticalDivider } from './VerticalDivider';

interface Props {
  editor: Editor;
}

export const EditorMenu = (props: Props) => {
  const { editor } = props;

  return (
    <ChakraV3.HStack gap={2} w='full' borderTopWidth='1px' borderBottomWidth='1px' py={1}>
      <AddNodeButton editor={editor} />
      <VerticalDivider />
      <NodeTypeSelect editor={editor} />
      <VerticalDivider />
      <MarkSelect editor={editor} />
      <VerticalDivider />
      <AlignmentSelect editor={editor} />
      <VerticalDivider />
      <IndentSelect editor={editor} />
      <VerticalDivider />
      <TextColorSelect editor={editor} />
      <VerticalDivider />
      <CommentButton editor={editor} />
      <ChakraV3.Spacer />
      <UndoRedo editor={editor} />
    </ChakraV3.HStack>
  );
};
